import template from './advertExperiencePage.html';
import controller from './advertExperiencePage.controller';
import './advertExperiencePage.scss';

let advertExperiencePageComponent = {
	restrict: 'E',
	bindings: {},
	template,
	controller
};

export default advertExperiencePageComponent;
